import { ExternalLink } from 'lucide-react'
import { Button } from '@/components/ui/button'

const ProductCard = ({ product }: { product: any }) => {
  return (
    <div className="flex flex-col items-center justify-between text-center rounded-2xl border border-border bg-card hover-lift hover:cursor-pointer hover:border-primary/40 pb-3 min-h-[280px] max-h-[280px] overflow-hidden transition-all">
      <div className="flex flex-col items-center justify-center w-full">
        <img src={product.image} alt={product.name} className="w-full h-auto object-contain" />
        <h1 className="text-lg font-semibold text-foreground mt-3 px-2">{product.name}</h1>
      </div>

      <Button onClick={() => window.open(product.link, '_blank')} className="gap-2 font-semibold">
        Comprar agora
        <ExternalLink className="h-4 w-4" />
      </Button>
    </div>
  )
}

export default ProductCard
